const findHotSale = products => (
    products.filter(product => product.promotion > 0)
 );
 
 export default findHotSale;